import { IRetailerIntegrationSurveyEntry } from "@faire/web-api--source/indigofair/retailer/IRetailerIntegrationSurveyEntry";
export var getIntegrationTypeName = function(type, strictLocalize) {
    switch(type){
        case IRetailerIntegrationSurveyEntry.IntegrationType.LIGHTSPEED:
            return "Lightspeed";
        case IRetailerIntegrationSurveyEntry.IntegrationType.TOAST:
            return "Toast";
        case IRetailerIntegrationSurveyEntry.IntegrationType.HEARTLAND:
            return "Heartland";
        case IRetailerIntegrationSurveyEntry.IntegrationType.ZETTLE:
            return "Zettle";
        case IRetailerIntegrationSurveyEntry.IntegrationType.SUM_UP:
            return "SumUp";
        case IRetailerIntegrationSurveyEntry.IntegrationType.OTHER:
            return strictLocalize({
                id: "/VnDMl",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Other"
                    }
                ]
            });
        default:
            return "";
    }
};
